import "./ClassSessionDetails.css";
import React, { useState, useContext } from "react";
import { MoonLoader } from "react-spinners";
import PrimaryButton from "../../../Components/Atoms/Buttons/Primary/PrimaryButton";
import FormModal from "../../../Components/Molecules/FormModal/FormModal";
import AddTaskForm from "../../../Components/Organisms/Forms/AddTaskForm/AddTaskForm";
import DeleteForm from "../../../Components/Molecules/DeleteForm/DeleteForm";
import { useLocation, useNavigate } from "react-router-dom";
import { BaseURL } from "../../../Hooks/URL";
import { userContext } from "../../../Contexts/userContext";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import DescriptionIcon from "@mui/icons-material/Description";
import AssignmentIcon from "@mui/icons-material/Assignment";
import ImageIcon from "@mui/icons-material/Image";
import AddIcon from "@mui/icons-material/Add";
import DownloadIcon from "@mui/icons-material/Download";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import BusinessIcon from "@mui/icons-material/Business";
import FilePreviewModal from "../../../Components/Organisms/FilePreviewModal/FilePreviewModal";
import PreviewIcon from "@mui/icons-material/Preview";

function ClassSessionDetails({
  sessionData,
  setTaskOpen,
  url,
  setGo,
  classId,
  lesson,
}) {
  console.log(lesson);
  const location = useLocation();
  const navigate = useNavigate();
  const { contextData } = useContext(userContext);
  const [previewAttachment, setPreviewAttachment] = useState(null);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);

  const handleDownloadAttachment = (attachment) => {
    const url = attachment.id
      ? `${BaseURL}/${attachment.filePath}`
      : URL.createObjectURL(attachment.file);

    const link = document.createElement("a");
    link.href = url;
    link.download = attachment.name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const handlePreviewAttachment = (attachment) => {
    setPreviewAttachment(attachment);
    setIsPreviewOpen(true);
  };

  const closePreview = () => {
    setPreviewAttachment(null);
    setIsPreviewOpen(false);
  };
  return (
    <div className="mainContainer">
      {sessionData && (
        <>
          <div className="courseActions">
            <button
              className="actionButton primary"
              onClick={() =>
                navigate(`/classes/${classId}/sessions/add/${sessionData?.id}`)
              }
            >
              Edit Session
            </button>
            {/* {!sessionData?.class_is_terminated && ( */}
            <DeleteForm
              setGo={setGo}
              title={"Are you sure to delete this session?"}
            />
            {/* )} */}
          </div>

          {/* Session Header Section */}
          <div className="contentSection">
            <div className="courseHeader">
              <div className="courseIconSection">
                <div className="titleIcon">
                  <CalendarTodayIcon />
                </div>
              </div>
              <div className="courseBasicInfo">
                <h1 className="courseName">
                  {sessionData?.title ?? "Session Details"}
                </h1>
              </div>

              <div className="courseStats">
                <div className="statItem">
                  <CalendarTodayIcon className="statIcon" />
                  <span className="statLabel">Session Date</span>
                  <span className="statValue">
                    {sessionData?.dateTime?.split("T")?.at(0) || "N/A"}
                  </span>
                </div>
                <div
                  className="statItem"
                  onClick={() => {
                    const taskSection = document.getElementById("task");
                    taskSection?.scrollIntoView({ behavior: "smooth" });
                  }}
                >
                  <AssignmentIcon className="statIcon" />
                  <span className="statLabel">Task Status</span>
                  <span className="statValue">
                    {sessionData?.task?.id ? "Assigned" : "No Task"}
                  </span>
                </div>
              </div>
            </div>

            <h2 className="sectionTitle">Session Details</h2>
            <div className="infoGrid">
              <div className="infoItem">
                <div className="infoLabel">
                  <DescriptionIcon className="infoIcon" />
                  Session Content
                </div>
                <div className="infoValue descriptionText">
                  {sessionData?.content || "No content available"}
                </div>
              </div>
            </div>

            <h2 className="sectionTitle" style={{ marginTop: "20px" }}>
              Lesson: {lesson?.title || "No title available"}
            </h2>
            <div className="infoGrid">
              <div className="infoItemLarge">
                <div className="infoLabel">
                  <DescriptionIcon className="infoIcon" />
                  Lesson Content
                </div>
                <div className="infoValue descriptionText">
                  {lesson?.content || "No content available"}
                </div>
              </div>
            </div>

            <h2 className="sectionTitle" style={{ marginTop: "20px" }}>
              Lesson Attachments
            </h2>
            {lesson?.attachments && lesson?.attachments.length > 0 ? (
              <div className="attachmentsGrid" style={{ marginTop: "20px" }}>
                {lesson?.attachments.map((attachment, index) => (
                  <div key={index} className="attachmentCard">
                    <div className="attachmentIcon">
                      <AttachFileIcon />
                    </div>
                    <div className="attachmentInfo">
                      <h4 className="attachmentName">{attachment.name}</h4>
                    </div>
                    <div style={{ display: "flex", gap: "8px" }}>
                      <button
                        className="actionButton secondary"
                        onClick={() => handlePreviewAttachment(attachment)}
                        title="Preview attachment"
                        style={{
                          padding: "12px",
                          minWidth: "auto",
                          fontSize: "18px",
                          background: "rgba(59, 130, 246, 0.1)",
                          color: "#3b82f6",
                          border: "1px solid rgba(59, 130, 246, 0.2)",
                        }}
                      >
                        <PreviewIcon />
                      </button>
                      {contextData?.role == "admin" && (
                        <button
                          className="actionButton primary"
                          onClick={() => handleDownloadAttachment(attachment)}
                          title="Download attachment"
                          style={{
                            padding: "12px",
                            minWidth: "auto",
                            fontSize: "18px",
                          }}
                        >
                          <DownloadIcon />
                        </button>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="emptyState">
                <BusinessIcon className="emptyIcon" />
                <h3>No Attachments</h3>
                <p>This lesson is not assigned to any attachments yet.</p>
              </div>
            )}

            {sessionData?.task ? (
              <>
                <h2 className="sectionTitle" style={{ marginTop: "20px" }}>
                  Task Assignment
                </h2>

                <div className="infoGrid">
                  <div className="infoItem" style={{ marginBottom: "16px" }}>
                    <div className="infoLabel">
                      <DescriptionIcon className="infoIcon" />
                      Task Description
                    </div>
                    <div className="infoValue descriptionText">
                      {sessionData?.task?.description ||
                        "No description available"}
                    </div>
                  </div>
                </div>

                <div className="lessonsHeader">
                  <h2 className="sectionTitle">Task Attachments</h2>
                </div>
                {sessionData?.task?.attachments &&
                sessionData?.task?.attachments.length > 0 ? (
                  <div className="attachmentsGrid">
                    {sessionData?.task?.attachments.map((attachment, index) => (
                      <div key={index} className="attachmentCard">
                        <div className="attachmentIcon">
                          <AttachFileIcon />
                        </div>
                        <div className="attachmentInfo">
                          <h4 className="attachmentName">{attachment.name}</h4>
                        </div>
                        <div style={{ display: "flex", gap: "8px" }}>
                          <button
                            className="actionButton secondary"
                            onClick={() => handlePreviewAttachment(attachment)}
                            title="Preview attachment"
                            style={{
                              padding: "12px",
                              minWidth: "auto",
                              fontSize: "18px",
                              background: "rgba(59, 130, 246, 0.1)",
                              color: "#3b82f6",
                              border: "1px solid rgba(59, 130, 246, 0.2)",
                            }}
                          >
                            <PreviewIcon />
                          </button>
                          <button
                            className="actionButton primary"
                            onClick={() => handleDownloadAttachment(attachment)}
                            title="Download attachment"
                            style={{
                              padding: "12px",
                              minWidth: "auto",
                              fontSize: "18px",
                            }}
                          >
                            <DownloadIcon />
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="emptyState">
                    <BusinessIcon className="emptyIcon" />
                    <h3>No Attachments</h3>
                    <p>This task is not assigned to any attachments yet.</p>
                  </div>
                )}
              </>
            ) : (
              <div className="emptyState">
                <AssignmentIcon
                  style={{
                    fontSize: "48px",
                    color: "#ccc",
                    marginBottom: "16px",
                  }}
                />
                <h3>No Task Assigned</h3>
                <p>This session doesn't have a task assigned yet.</p>
              </div>
            )}
          </div>
        </>
      )}

      {/* File Preview Modal */}
      <FilePreviewModal
        attachment={previewAttachment}
        isOpen={isPreviewOpen}
        onClose={closePreview}
        baseURL={BaseURL}
      />
    </div>
  );
}

export default ClassSessionDetails;
